// extracted by mini-css-extract-plugin
module.exports = {"container":"_21Hu7","mobile":"_2JVfb","full":"_1lmaM","rounded":"K0T0e"};